/** @format */

import React from 'react';

import {
    PROOF_INTERNAL_NOT_TRACKING,
    PROOF_TYPE_PRINTED,
    PROOF_STATUS_PENDING,
    PROOF_INTERNAL_COMPLETE,
    PROOF_STATUS_DISAPPROVED
} from 'frontier-constants';

import {Textarea, handleChange} from 'frontier-form';
import withProofApprovalHandler from './with_proof_approval_handler';
import {ConditionalButton} from 'frontier-utilities';

export default withProofApprovalHandler(
    handleChange(props => {
        if (
            parseInt(props.type_id) === PROOF_TYPE_PRINTED &&
            parseInt(props.internal_status) !== PROOF_INTERNAL_COMPLETE
        ) {
            return <React.Fragment>Proof is Printing</React.Fragment>;
        }

        if (props.status_id !== PROOF_STATUS_PENDING) {
            return (
                <span style={{cursor: 'pointer'}} onClick={props.onToggle}>
                    {props.status_label}
                    {!props.expanded && props.status_id === PROOF_STATUS_DISAPPROVED && (
                        <span className="text-danger ml-2">{props.disapprove_reason}</span>
                    )}
                    {props.expanded && props.status_id === PROOF_STATUS_DISAPPROVED && (
                        <div className="text-danger ml-2" style={{whiteSpace: 'pre-wrap'}}>
                            {props.disapprove_reason}
                        </div>
                    )}
                </span>
            );
        }

        return (
            <a
                href={`/account/proofs/view/${props.order_id}`}
                className="btn btn-warning"
                style={{padding: '5px 16px'}}>
                Review Proof
            </a>
        );

        return (
            <ConditionalButton enabled={!props.disapproving}>
                <ConditionalButton enabled={!props.approving}>
                    <div className="d-flex">
                        <button className="btn btn-sm btn-success" onClick={props.onApprove}>
                            I Approve!
                        </button>
                        <span className="ml-2 mr-2">OR</span>

                        <button className="btn btn-sm btn-danger" onClick={props.onDisapprove}>
                            Something's Wonky.
                        </button>
                    </div>
                    <button className="btn btn-sm btn-success" disabled="disabled">
                        I'm Approvin..
                    </button>
                </ConditionalButton>

                <ConditionalButton enabled={!props.disapprovingRequest}>
                    <div className="p-4 m-4" style={{border: 'solid 1px #ccc'}}>
                        <div className="mb-2" style={{whiteSpace: 'pre-wrap'}}>
                            Describe what's wrong and we'll get you a new proof in a jiffy.
                        </div>
                        <div className="mb-2">
                            <Textarea
                                className="form-control"
                                value={props.disapproveReason}
                                onChange={props.onInputChange.bind(this, 'disapproveReason')}
                            />
                        </div>
                        <button
                            className="btn btn-danger mr-4 btn-sm"
                            onClick={props.onDisapproveConfirm}>
                            Confirm Disapproval
                        </button>
                        <button
                            className="btn btn-sm btn-outline-secondary"
                            onClick={props.onCancelDisapprove}>
                            Cancel
                        </button>
                    </div>
                    <div>
                        <div className="text-danger">{props.disapproveReason}</div>
                        <button className="btn btn-sm btn-danger" disabled="disabled">
                            I'm Disapproving...
                        </button>
                    </div>
                </ConditionalButton>
            </ConditionalButton>
        );
    })
);
